module.exports = __webpack_public_path__ + "img/3-7.0db67c9a.png";